(() => {
  angular
    .module('gm.common.services')
    .factory('btgRegions', btgRegionsFactory);

  function btgRegionsFactory(
    gmApi,
    promiseCache
  ) {
    'ngInject';

    function getRegions(bustCache = false) {
      return promiseCache({
        bustCache,
        promise: () => gmApi.get('regions'),
        ttl: 600000
      });
    }

    function prepareCountry({ code: id, name }) {
      return {
        name,
        id: id ? id.toUpperCase() : id,
        flag: id.toLowerCase()
      };
    }

    function getCountriesOptions() {
      return getRegions().then(({ countries }) => countries.map(prepareCountry));
    }

    return {
      getRegions,
      getCountriesOptions
    };
  }
})();
